import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";

export default class MedicalPracticeRequest extends MainRequest {
  static delete(data) {
    return this.postSEC(ServicePath.MEDICAL_PRACTICE_CANCEL, data);
  }

  static get(data) {
    return this.postSEC(ServicePath.MEDICAL_PRACTICE_LIST_BY_ID, data);
  }

  static listAll(data) {
    return this.postSEC(
      ServicePath.MEDICAL_PRACTICE_BY_STATUS_AND_SPECIALITY,
      data
    );
  }
  // static add(data) {
  //   return this.postSEC(ServicePath.PROCEDURE_APPLICATION_ADD, data);
  // }
  static add(data) {
    return this.postSEC(ServicePath.PROCEDURE_APPLICATION_ADD, data);
  }
}
